import { TEMPTED_BACKEND } from '../../../../../../../../constants/apiUrls/apiUrls';


export async function getGalleryTempObjectRequest(galleryUrl) {
  const createHeaders = () => {
    const obj = { username: '', Authorization: '' };
    if (sessionStorage.getItem('username')) {
      obj.username = sessionStorage.getItem('username');
    }
    if (sessionStorage.getItem('token')) {
      obj.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
    }

    return obj;
  };

  let url = galleryUrl;

  if (galleryUrl.indexOf('https://') === -1 && galleryUrl.indexOf('http://') === -1) {
    url = TEMPTED_BACKEND + url;
  }

  const response = await fetch(url, { headers: createHeaders() });

  if (response) {
    const json = await response.json();

    if (json) {
      return json;
    }
  }

  return null;
}
